export default {
      id: "ic-misc-favorite-usage",
      viewBox: "0 0 25 25",
      url: "../dist/images/" + "sprite.svg#ic-misc-favorite-usage",
      toString: function () {
        return this.url;
      }
    }